export enum FormErrorTypes {
  required = 'required',
  pattern = 'pattern',
  minLength = 'minLength',
  maxLength = 'maxLength',
}

const errorMessages: { [key: string]: any } = {
  [FormErrorTypes.required]: (param: any, t: any) => t('errorForm.required'),
  [FormErrorTypes.pattern]: (param: any, t: any) => t('errorForm.valid', { param }),
  [FormErrorTypes.minLength]: (param: any, t: any) => t('errorForm.minimum', { param }),
  [FormErrorTypes.maxLength]: (param: any, t: any) => t('errorForm.maximum', { param }),
};

export const getErrorMsg = (type: FormErrorTypes, t: any, errObj?: any) => {
  return errorMessages[type](errObj, t);
};
